import React from 'react';
import { Radio } from 'tea-component';
import BubbleCommon from '../../../BubbleCommon';
import { arrayToSimpleObj } from '@op/utils';
import useLanguage from '@op/hooks/useLanguage'; 
import { KeywordListModeType } from '../../types';

interface KeywordsModeHeaderProps {
  keywordListMode: KeywordListModeType;
  setKeywordListMode: (value: KeywordListModeType) => void;
}

const modeOptions = [
  {
    text: 'Include',
    value: 'include' as KeywordListModeType,
    tips: {
      zh: '筛选包含所选关键词的评论',
      en: 'Filter reviews that contain the selected keywords',
    },
  },
  {
    text: 'Exclude',
    value: 'exclude' as KeywordListModeType,
    tips: {
      zh: '排除包含所选关键词的评论',
      en: 'Exclude reviews that contain the selected keywords',
    },
  },
];

export const modeOptionsMap = arrayToSimpleObj(modeOptions, 'text', 'value');

export default function KeywordsModeHeader({
  keywordListMode,
  setKeywordListMode,
}: KeywordsModeHeaderProps) {
  const { formatMessage } = useLanguage();

  return (
    <div className="dbo-keywords-mode-header">
      <Radio.Group
        value={keywordListMode}
        onChange={(value: any) => setKeywordListMode(value)}
      >
        {modeOptions.map(({ text, value: modeValue, tips }) => (
          <BubbleCommon
            tipsMap={tips}
            placement="top"
            showIcon={false}
            key={modeValue}
          >
            <Radio name={modeValue}>{formatMessage({ id: text })}</Radio>
          </BubbleCommon>
        ))}
      </Radio.Group>
    </div>
  );
}
